
<template>
    <!-- <div class="theme">
        <el-color-picker
            v-model="color" 
            @change="handleOnColor" 
            size="small"
        ></el-color-picker>
    </div> -->
    <div style="margin-left: -10px;">
        <el-row>
            <el-col :span="12">
                <div class="item" :class="activeKey === 0 ? 'select' : ''" style="width:200px;height: 180px;" @click="clickTheme()">
                    <div style="border:0px solid black;height: 30px;background-color: #255F9E;"></div>
                    <el-row>
                        <el-col :span="6">
                            <div style="border:0px solid black;width: 99%;height: 150px;background-color: #23345e;"></div>
                        </el-col>
                        <el-col :span="18">
                            <div style="border:0px solid black;width: 99%;;height: 150px;background-color: #e8e5e5;"></div>
                        </el-col>
                    </el-row>
                </div>
            </el-col>
            <el-col :span="12">
                <div class="item" :class="activeKey === 1 ? 'select' : ''" style="width:200px;height: 180px;" @click="clickTheme1()">
                    <div style="border:0px solid black;height: 30px;background-color: #0680c7;"></div>
                    <el-row>
                        <el-col :span="6">
                            <div style="border:0px solid black;width: 99%;height: 150px;background-color: #10a1d2;"></div>
                        </el-col>
                        <el-col :span="18">
                            <div style="border:0px solid black;width: 99%;;height: 150px;background-color: #e8e5e5;"></div>
                        </el-col>
                    </el-row>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
 
<script>
import { updateSkin } from '../api/api';
export default {
    name: 'Theme',
    data () {
        return {
            color: '',
            activeKey:0
        };
    },
    created() {
        this.color = this.mTheme;
        this.onloadColor();
    },
    watch: {
        mTheme(val) {
            this.color = val;
        }
    },
    computed: {
        theme () {
            return this.$store.state.theme;
        }
    },
    methods: {
        onloadColor(){
            const themeColor=this.$store.state.theme
            const headerColor=this.$store.state.header
            if(themeColor=="#23345e"&&headerColor=="#255F9E"){
                this.activeKey=0
            }else{
                this.activeKey=1
            }
        },
        handleOnColor(value) {
            this.$store.dispatch('UPDATE_THEME', value);
        },
        clickTheme(){
            this.$store.dispatch('UPDATE_THEME', "#23345e");
            this.$store.dispatch('UPDATE_HEADER', "#255F9E");
            localStorage.setItem("theme","#23345e")
            localStorage.setItem("header","#255F9E")
            this.activeKey=0
            let _params={
                skin:"theme"
            }
            updateSkin(_params).then(datas=>{
                let {data,status,message} =datas
                if(status==200){
                    this.$message({ message: '修改皮肤成功', type: 'success' });
                }
            })
        },
        clickTheme1(){
            this.$store.dispatch('UPDATE_THEME', "#0680c7");
            this.$store.dispatch('UPDATE_HEADER', "#10a1d2");
            localStorage.setItem("theme","#0680c7")
            localStorage.setItem("header","#10a1d2")
            this.activeKey=1
            let _params={
                skin:"theme1"
            }
            updateSkin(_params).then(datas=>{
                let {data,status,message} =datas
                if(status==200){
                    this.$message({ message: '修改皮肤成功', type: 'success' });
                }
            })
        }
    },
    destroyed () {
    }
}
</script>
 
<style  scoped>

.item {
		border: 1px #AAAAAA solid;
		padding: 1vh 1vh;
		border-radius: 5px;
		margin: 1vh 1vw;
	}

	.shift {
		font-weight: 600;
		margin-bottom: 10px;
	}

	.select {
		position: relative;
		text-align: left;
		color: #00aaff;
		background-color: #fff;
		box-shadow: 0px 2px 7px 0px rgba(85, 110, 97, 0.35);
		border-radius: 5px;
		border: 1px solid #00aaff;
	}

	.select:before {
		content: '';
		position: absolute;
		right: 0;
		bottom: 0;
		border: 10px solid #00aaff;
		border-top-color: transparent;
		border-left-color: transparent;
	}

	.select:after {
		content: '';
		width: 4px;
		height: 6px;
		position: absolute;
		right: 4px;
		bottom: 3px;
		border: 2px solid #fff;
		border-top-color: transparent;
		border-left-color: transparent;
		transform: rotate(45deg);
	}


</style>


// WEBPACK FOOTER //
// src/components/theme.vue